import React from 'react';

const formatUsd = (value) => {
  if (!Number.isFinite(value)) return '—';
  return `$${value.toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
};

export default function PortfolioKpiRow({ totalUsd, perChainUsd }) {
  return (
    <div className="card" style={{ display: 'grid', gap: '0.75rem' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '0.75rem' }}>
        <div>
          <div className="muted small">Total Portfolio</div>
          <div className="big">{formatUsd(totalUsd)}</div>
        </div>
        <div>
          <div className="muted small">Ethereum</div>
          <div className="big">{formatUsd(perChainUsd?.ethereum)}</div>
        </div>
        <div>
          <div className="muted small">Arbitrum</div>
          <div className="big">{formatUsd(perChainUsd?.arbitrum)}</div>
        </div>
      </div>
    </div>
  );
}
